import React from 'react'
import { RadioActiveIcon, RadioInactiveIcon } from '../../conf/images'
import './index.css'
interface RadioItemProps {
    selected?: boolean
    label?: React.ReactNode
    onSelect?: () => void
    className?: string
}
const RadioItem: React.FC<RadioItemProps> = (props) => {
    return (
        <div
            className={`radio-item ${props.className || ''}`}
            onClick={props.onSelect}
        >
            {props.selected && (
                <img className='radio-icon' src={RadioActiveIcon} alt='icon' />
            )}
            {!props.selected && (
                <img
                    className='radio-icon'
                    src={RadioInactiveIcon}
                    alt='icon'
                />
            )}
            {props.label && <span className='radio-label'>{props.label}</span>}
            {props.children}
        </div>
    )
}

export default RadioItem
